<template>
  <div>
    <BlockHeader name="Company Information" />
    <div class="row">
      <div class="col-lg-6 col-sm-12 col-xs-12">
        <Input v-model="settingsLocal.companyName" form-group-id="companyName" placeholder="Company name" />
        <Input v-model="settingsLocal.companyImprint" form-group-id="companyImprint" placeholder="Company imprint" />
        <Input v-model="settingsLocal.companyAddress1" form-group-id="Company Address 1" placeholder="Company Address (Line 1)" />
        <Input v-model="settingsLocal.companyAddress2" form-group-id="Company Address 2" placeholder="Company Address (Line 2)" />
        <Select v-model="settingsLocal.defaultProjectPdf" :options="Object.values(PROJECT_PDF_TYPES)" placeholder="Project PDF" />
        <Select v-if="isCompanyLoaded" v-model="settingsLocal.defaultOrderingCompany" placeholder="Ordering company" :options="companies" />
      </div>
      <div class="col-lg-6 col-sm-12 col-xs-12">
        <FileInput v-model="settingsLocal.companyLogo" form-group-id="companyLogo" placeholder="Company logo" />
        <div class="img-wrapper">
          <!-- ?dummy=${Math.random() added for avoid caching  -->
          <img
            v-show="logoLoaded"
            :src="`${baseURL}/api/v1/static/pdf-templates/companyLogo.png?dummy=${Math.random()}`"
            alt="No pdf template"
            class="img-preview"
            @error="errorImgLoaded()"
            @load="imgLoaded()"
          />
          <div v-show="!logoLoaded">Logo no found</div>
        </div>
      </div>
    </div>
    <BlockHeader name="Offline mode" />
    <div class="row">
      <div class="col-lg-6 col-sm-12 col-xs-12">
        <Input
          v-model="settingsLocal.timeForDisablingOfflineMode"
          form-group-id="timeForDisablingOfflineMode"
          placeholder="Time for disabling offline mode (min)"
          type="number"
        />
      </div>
    </div>
    <BlockHeader name="Image resolution" />
    <div class="row">
      <div class="col-lg-6 col-sm-12 col-xs-12">
        <Checkbox
          v-model="settingsLocal.setupMaxImgResolution"
          form-group-id="setupMaxImgResolution"
          placeholder="Set up image resolution (from 0 to 1000)"
          :bottom="0"
        />
        <Input
          v-model="settingsLocal.maxImgResolution"
          form-group-id="maxImgResolution"
          type="number"
          :min="0"
          :max="1000"
          :disabled="!settingsLocal.setupMaxImgResolution"
          @input="handleResolutionInput"
        />
      </div>
    </div>
    <BlockHeader name="Global notifications" />
    <div class="row">
      <div class="col-lg-6 col-sm-12 col-xs-12">
        <Checkbox
          v-model="settingsLocal.enableGlobalNotifications"
          form-group-id="enableGlobalNotifications"
          placeholder="Enable global notifications"
        />
      </div>
    </div>
    <BlockHeader name="Reports Mobile App" />
    <div class="row">
      <div class="col-lg-6 col-sm-12 col-xs-12">
        <div class="lable-header">{{ 'Display mode' | i18n }}</div>
        <div>
          <Radio v-model="settingsLocal.reportsAppDisplayMode" :options="optionsDisplayMode" small formGroupId="reportsAppDisplayMode" />
        </div>
      </div>
    </div>
    <BlockHeader name="Report Layout" />
    <div class="row">
      <div class="col-lg-6 col-sm-12 col-xs-12">
        <div class="lable-header">{{ 'Position of Company Name & Address' | i18n }}</div>
        <div>
          <Radio v-model="settingsLocal.reportLayoutCompanyPosition" :options="optionsPosition" small formGroupId="position of company" />
        </div>
        <div class="lable-header">{{ 'Position of Company Logo' | i18n }}</div>
        <div>
          <Radio v-model="settingsLocal.reportLayoutLogoPosition" :options="optionsPosition" small formGroupId="position of logo" />
        </div>
        <div class="reports-logo">
          <Checkbox
            v-model="settingsLocal.reportLayoutRepeatedInformation['Reports Logo']"
            placeholder="Show Reports Logo"
            form-group-id="Reports Logo"
          />
        </div>
        <div class="lable-header">{{ 'Information to be repeated on following pages' | i18n }}:</div>
        <div class="lable-subheader">{{ 'Header' | i18n }}:</div>
        <div>
          <Checkbox v-model="settingsLocal.reportLayoutRepeatedInformation['Company Name']" placeholder="Company Name" form-group-id="Company Name" />
          <Checkbox v-model="settingsLocal.reportLayoutRepeatedInformation['Company Logo']" placeholder="Company Logo" form-group-id="Company Logo" />
          <Checkbox v-model="settingsLocal.reportLayoutRepeatedInformation['Page No']" placeholder="Page No" form-group-id="Page No" />
          <Checkbox v-model="settingsLocal.reportLayoutRepeatedInformation['Report Name']" placeholder="Report Name" form-group-id="Report Name" />
          <Checkbox
            v-model="settingsLocal.reportLayoutRepeatedInformation['Report Person']"
            placeholder="Report Person"
            form-group-id="Report Person"
          />
        </div>
        <div class="lable-subheader">{{ 'Footer' | i18n }}:</div>
        <div>
          <Checkbox
            v-model="settingsLocal.reportLayoutRepeatedInformation['Report Name Footer']"
            placeholder="Report Name"
            form-group-id="Report Name Footer"
          />
          <Checkbox
            v-model="settingsLocal.reportLayoutRepeatedInformation['Company Name Footer']"
            placeholder="Company Name"
            form-group-id="Company Name Footer"
          />
          <Checkbox v-model="settingsLocal.reportLayoutRepeatedInformation['Imprint Footer']" placeholder="Imprint" form-group-id="Imprint Footer" />
          <Checkbox v-model="settingsLocal.reportLayoutRepeatedInformation['Page No Footer']" placeholder="Page No" form-group-id="Page No Footer" />
        </div>
      </div>
      <div class="col-lg-6 col-sm-12 col-xs-12">
        <div style="display: flex; flex-wrap: wrap">
          <div style="margin: 0 50px 20px 0">
            <div class="lable-header">{{ 'Banner Color' | i18n }}</div>
            <div>
              <Chrome :value="settingsLocal.reportLayoutBannerColor" @input="updateColor" />
            </div>
          </div>
          <div>
            <div class="lable-header">{{ 'Text Color' | i18n }}</div>
            <div>
              <Chrome :value="settingsLocal.reportLayoutTextColor" @input="updateTextColor" />
            </div>
          </div>
        </div>
        <div
          :style="`background:${settingsLocal.reportLayoutBannerColor};color:${settingsLocal.reportLayoutTextColor}; padding: 15px; width: 100%;margin-top: 20px;font-weight: bold;`"
        >
          {{ 'Banner Color' | i18n }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import { Chrome } from 'vue-color';
import api from '../../../../api/index';
import Checkbox from '../../../common/checkbox';
import Radio from '../../../common/radio';
import Input from '../../../common/input/index';
import Select from '../../../common/select';
import FileInput from '../../../common/fileInput/index';
import BlockHeader from '../../../common/block-header';
import { ApiMixin } from '../../../../../mixins';
import { PROJECT_PDF_TYPES } from '../../../../../../../../constants';

export default {
  name: 'GeneralSettings',
  components: { Input, BlockHeader, FileInput, Radio, Chrome, Checkbox, Select },
  mixins: [ApiMixin],
  props: {
    settings: {
      type: Object,
      default: () => {},
    },
  },
  data: function () {
    return {
      baseURL: axios.defaults.baseURL,
      logoLoaded: false,
      optionsPosition: [
        { value: 'left', text: this.$translate('Top left') },
        { value: 'right', text: this.$translate('Top right') },
      ],
      optionsDisplayMode: [
        { value: 'list', text: this.$translate('List') },
        { value: 'groupedList', text: this.$translate('Grouped List') },
        { value: 'all', text: this.$translate('All') },
      ],
      PROJECT_PDF_TYPES,
      companies: [],
      isCompanyLoaded: false,
    };
  },
  computed: {
    settingsLocal: {
      get: function () {
        return this.settings;
      },
      set: function (value) {
        this.$emit('settings', value);
      },
    },
  },
  async mounted() {
    await this.getCompanies();
  },
  methods: {
    updateColor(c) {
      this.settingsLocal.reportLayoutBannerColor = c.hex;
    },
    updateTextColor(c) {
      this.settingsLocal.reportLayoutTextColor = c.hex;
    },
    errorImgLoaded() {
      this.logoLoaded = false;
    },
    imgLoaded() {
      this.logoLoaded = true;
    },
    handleResolutionInput() {
      this.settingsLocal.maxImgResolution = Math.max(0, Math.min(1000, this.settingsLocal.maxImgResolution));
    },
    async getCompanies() {
      try {
        const companies = await api.commonCompany.get();
        this.companies = companies.map((c) => {
          return { value: c.id, text: c.name };
        });
        this.loaded = true;
        this.isCompanyLoaded = true;
      } catch (err) {
        Notification({ type: 'error', message: err.message });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.img-wrapper {
  padding-top: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.img-preview {
  width: 100%;
  box-shadow: 0px 0px 20px 1px rgba(0, 0, 0, 0.21);
}
.lable-header {
  margin-bottom: 10px;
  font-size: 20px;
}
.lable-subheader {
  margin-bottom: 10px;
  font-size: 17px;
  font-weight: 600;
}
.reports-logo {
  margin-bottom: 20px;
}

.form-group-checkbox {
  margin-bottom: 5px;
}
</style>
